{
    "name": "Cherry Tomato",
    "binomial_name": "Solanum lycopersicum",
    "common_names": [
        "Cherry tomato",
        "red robin"
    ],
    "description": "This variety can be grown in pots.",
    "sun_requirements": "",
    "sowing_method": "",
    "spread": 0,
    "row_spacing": 0,
    "height": 25,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/cherry-tomato.jpg",
    "icon": "/crops/icons/cherry-tomato.avif"
}